import styled from 'styled-components'
import { Form, Input, Button } from 'global/styles/styles.js';

const S = {};

S.ParagonexForm = styled(Form)` 
    min-height: 70vh;
    display: flex;
    justify-content: center;
    align-items: center;
`;

S.ToggleTransferForm = styled.div` 
    display: flex;
    background: #535355;
    position: fixed;
    right: 0;
    width: 100px;
    top: 19rem;
    font-size: 13px;
    color: #fff;
    cursor: pointer;
    padding: 1rem;
    align-items: center;
    justify-content: center;
    width: fit-content;
    z-index: 101;
    writing-mode: vertical-rl;
    text-orientation: mixed;  
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;

    &:hover {
        background: #5a5866;
    }

    & > span:last-of-type {
        width: 0;
        height: 0;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid #bfbdca;
        transition-duration: 1s;
        margin: 0.5rem 0 0;

        transform: ${({toggleTransferForm}) => {
            return toggleTransferForm ? 'rotate(-90deg);' : 'rotate(90deg);';
    }};
    }

    & > span {
        white-space: nowrap;
        transform: rotate(180deg);
    }
`;

S.ParagonexTradeRoom = styled.div` 
    display: flex;

    .paragonexTransfer-transition-enter,
    .paragonexTransfer-transition-appear {
        top: 0;
        max-width: 0px;
        color: transparent;
    }

    .paragonexTransfer-transition-enter-active,
    .paragonexTransfer-transition-appear-active {
        max-width: 533px;
        transition: all 800ms;
    }

    .paragonexTransfer-transition-exit {
        max-width: 533px;
        color: transparent;
    }

    .paragonexTransfer-transition-exit-active {
        max-width: 0px;
        color: transparent;
        transition: all 800ms;
    }
`;

S.ParagonexIframe = styled.iframe` 
    width: 100%;
    height: 100vh;
`;

S.Iframe = styled.iframe`
  border: 0;
  width: 100%;
`

S.Row = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

S.InputWrapper = styled.div`
    position: relative;
    margin-bottom: 2.25rem;
    width: 100%;
`;

S.Input = styled(Input)`
    box-shadow: none;
    display: block;
    width: 100%;
    height: 3rem;
    -webkit-text-security: disc;
    &.has-error{
        border: .08rem solid red;
    }
    &.is-valid{
        border: .08rem solid #63dd7d;
    }
`;

S.Hint = styled.div`
    position: absolute;
    top: 45px;
    right: 9px;
`;

S.HintIcon = styled.div`
    cursor: pointer;
    width: 21px;
    height: 21px;
    display: flex;
    justify-content: center;
    align-items: center;
    
    & svg{
      width: 100%;
    }
`;

S.Error = styled.div`
    color: red;
    margin-top: 0;
    font-size: 0.9rem;
`;

S.Label = styled.label`
    margin-top: 1rem;
    margin-right: 2.08rem;
    padding: 0 0 0 1rem;
    position: relative;
    display: flex;
    overflow: hidden;
    color: #6D6D6D;
    text-transform: uppercase;
    font-size: 1.1rem;
    font-weight: bold;
`;

S.AuthorizationMethodChooser = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content: space-around;
    margin: 1rem 0;
`;

S.AuthorizationMethodFields = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

S.AuthorizationMethod = styled.div`
    color: #6D6D6D;
    text-transform: uppercase;
    font-size: 1.3rem;
    font-weight: bold;
    cursor: pointer;
    position: relative;
    color: #4B4B4D;
    font-weight: ${({ isActive }) => (isActive == true ? 700 : 400)};
    color: ${({ isActive }) => (isActive == true ? '#f8941e' : '#4b4b4d')};

    &:after{
        content: '';
        height: 3px;
        background-color: #09a83b;
        display: ${({ isActive }) => (isActive == true ? 'block' : 'none')};
        left:0;
        right:0;
        width: auto;
        position: absolute;
    }
`;

S.Body = styled.div`
    width: 20%;
    height: 50vh;
`;

S.Cover = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,0.5);
    justify-content: center;
    align-items: center;
    display: flex;
    z-index: 5;
`;

S.SubmitBtn = styled(Button)`
    border: none;
    background-color: #09A83B;
    
    cursor: pointer;
    display: block;
    cursor: pointer;
    box-shadow: 0px 1px 1px #00000029;
    height: 3rem;
    color: #fff;
    font-size: 1.2rem;
    font-weight: 600;
    text-align: center;
    transition-duration: 1s;

    &:disabled {
        background-color: #424242;
        opacity: 0.5;
        transition-duration: 1s;
    } 
`;     

S.SubmissionError = styled.div`
    margin: 0;
    border-radius: .25rem;
    width: 100%;
    color: red;
    font-size: 1rem;
    text-align: left;
    padding: .83rem;
    background-color: #fba59f;
    margin-bottom: 1rem;
`;

export default S;
